import { useState, useEffect } from "react";

const APPS_SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzUpP1w877CvzS830UmzMook7rGT1sBx9frQfnS9ZgZTES69jfVyGFgwVVMsfbOfw7E/exec";

export default function VerifyCertificate() {
  const [certificateId, setCertificateId] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const certId = params.get("certificate_id");
    if (certId) {
      setCertificateId(certId);
      verifyById(certId);
    }
  }, []);

  const verifyById = async (id) => {
    if (typeof id !== "string" || !id.trim()) return;

    const cleanId = id.trim().toUpperCase();

    setLoading(true);
    setError("");
    setResult(null);

    try {
      const res = await fetch(`${APPS_SCRIPT_URL}?id=${cleanId}`);
      const data = await res.json();

      if (data.found) {
  const d = data.data;
  const formatDate = (val) => {
    if (!val) return "";
    const date = new Date(val);
    if (isNaN(date)) return val; // if not a valid date, return as-is
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  };
  d.start_date = formatDate(d.start_date);
  d.end_date = formatDate(d.end_date);
  d.issue_date = formatDate(d.issue_date);
  setResult({ valid: true, id: cleanId, ...d });
      } else {
        setResult({ valid: false });
      }
    } catch (err) {
      setError("Unable to verify certificate. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="verify-section">
      <div className="verify-card">
        <h1 className="verify-title">Certificate Verification</h1>
        <p className="verify-subtitle">
          Enter the certificate ID to verify authenticity
        </p>

        <input
          className="verify-input"
          type="text"
          placeholder="INTLRR-2026-XXXX"
          value={certificateId}
          onChange={(e) => setCertificateId(e.target.value)}
        />

        <button
          className="verify-button"
          onClick={() => verifyById(certificateId)}
          disabled={loading}
        >
          {loading ? "Verifying…" : "Verify Certificate"}
        </button>

        {error && <p className="verify-error">{error}</p>}

        {result && result.valid && (
          <div className="verify-result success">
            <div className="verify-badge">Valid</div>

            <div className="verify-grid">
              <div>
                <span>Certificate ID</span>
                <strong>{result.id}</strong>
              </div>
              <div>
                <span>Recipient Name</span>
                <strong>{result.name}</strong>
              </div>
              <div className="full">
                <span>Course</span>
                <strong>{result.course}</strong>
              </div>
              <div>
                <span>Completion Period</span>
                <strong>
                  {result.start_date} to {result.end_date}
                </strong>
              </div>
              <div>
                <span>Issue Date</span>
                <strong>{result.issue_date}</strong>
              </div>
            </div>

            <div className="verify-footer">
              ✓ This certificate has been verified as authentic and issued by
              Intlrr.
            </div>
          </div>
        )}

        {result && !result.valid && (
          <div className="verify-result error">
            <p>
              <strong>Certificate not found.</strong>
            </p>
            <p style={{ marginTop: "8px", fontSize: "14px", color: "#7f1d1d" }}>
              Note: Our public verification records are updated periodically. If
              your certificate was issued recently, it may take up to{" "}
              <strong>30 days</strong> to appear here.
            </p>
            <p style={{ marginTop: "6px", fontSize: "14px" }}>
              For assistance, please contact{" "}
              <a
                href="mailto:support@intlrr.com"
                style={{ color: "#7f1d1d", textDecoration: "underline" }}
              >
                support@intlrr.com
              </a>
              .
            </p>
          </div>
        )}
      </div>
    </section>
  );
}